export default {
	name: 'school-information',
	path: '/school-information',
	meta: {
		title: '信息中心'
	},
	redirect: '/school-information/staff',
	children: [
		{
			name: 'info-school',
			path: 'school',
			meta: {
				title: '学校管理'
			},
			redirect: '/school-information/school/search',
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/school'),
			children: [
				{
					name: 'school-search',
					path: 'search',
					fullPath: '/school-information/school/search',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/school/search')
				},
				{
					name: 'school-add',
					path: 'add',
					fullPath: '/school-information/school/add',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/school/add')
				},
				{
					name: 'school-audit',
					path: 'audit',
					fullPath: '/school-information/school/audit',
					meta: {
						// title: '审核'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/school/audit')
				},
				{
					name: 'school-graduationManage',
					path: 'graduationManage',
					fullPath: '/school-information/school/graduationManage',
					meta: {
						// title: '毕业管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/school/graduationManage')
				},
				{
					name: 'school-basisDataExport',
					path: 'basisDataExport',
					fullPath: '/school-information/school/basisDataExport',
					meta: {
						// title: '导出迈奇拓学校数据'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/school/basisDataExport')
				}
			]
		},
		{
			name: 'info-staff',
			path: 'staff',
			meta: {
				title: '职工管理'
			},
			redirect: '/school-information/staff/search',
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/staff'),
			children: [
				{
					name: 'staff-search',
					path: 'search',
					fullPath: '/school-information/staff/search',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/staff/search')
				},
				{
					name: 'staff-add',
					path: 'add',
					fullPath: '/school-information/staff/add',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/staff/add')
				},
				{
					name: 'staff-manage',
					path: 'manage',
					fullPath: '/school-information/staff/manage',
					meta: {
						// title: '职位管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/staff/manage')
				}
			]
		},
		{
			name: 'info-student',
			path: 'student',
			fullPath: '/school-information/student',
			meta: {
				title: '学生管理',
				icon: 'icon-home'
			},
			redirect: '/school-information/student/search',
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/student'),
			children: [
				{
					name: 'student-search',
					path: 'search',
					fullPath: '/school-information/student/search',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/student/search')
				},
				{
					name: 'student-edit',
					path: 'edit',
					fullPath: '/school-information/student/edit',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/student/edit')
				}
			]
		},
		{
			name: 'info-parent',
			path: 'parent',
			redirect: '/school-information/parent/check',
			meta: {
				title: '家长管理',
				icon: ''
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/parent'),
			children: [
				{
					name: 'parent-check',
					path: 'check',
					fullPath: '/school-information/parent/check',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/parent/check')
				}
			]
		},
		{
			name: 'info-class',
			path: 'class',
			redirect: '/school-information/class/search',
			meta: {
				title: '班级管理',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/class'),
			children: [
				{
					name: 'class-search',
					path: 'search',
					fullPath: '/school-information/class/search',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/class/search')
				},
				{
					name: 'class-add-class',
					path: 'add-class',
					fullPath: '/school-information/class/add-class',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/class/add-class')
				},
				{
					name: 'class-class-order',
					path: 'class-order',
					fullPath: '/school-information/class/class-order',
					meta: {
						// title: '班级排序'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/class/class-order')
				}
			]
		},
		{
			name: 'info-lession',
			path: 'lession',
			fullPath: '/school-information/lession',
			meta: {
				title: '课程管理'
			},
			redirect: '/school-information/lession/set-course',
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/lession'),
			children: [
				{
					name: 'lession-set-course',
					path: 'set-course',
					fullPath: '/school-information/lession/set-course',
					meta: {
						// title: '设置课程'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/lession/set-course')
				}
			]
		},
		{
			name: 'info-subject',
			path: 'subject',
			fullPath: '/school-information/subject',
			meta: {
				title: '科目管理',
				icon: 'icon-home'
			},
			redirect: '/school-information/subject/subject-list',
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/subject'),
			children: [
				{
					name: 'subject-subject-list',
					path: 'subject-list',
					fullPath: '/school-information/subject/subject-list',
					meta: {
						// title: '科目列表'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/subject/subject-list')
				},
				{
					name: 'subject-add-subject',
					path: 'add-subject',
					fullPath: '/school-information/subject/add-subject',
					meta: {
						// title: '增加科目'
					},
					component: () =>
						import(/* webpackChunkName: "school-information" */ '@/views/school-information/subject/add-subject')
				}
			]
		},
		{
			name: 'info-recycle',
			path: 'recycle',
			fullPath: '/school-information/recycle',
			meta: {
				// title: '回收站',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/recycle')
		},
		{
			name: 'wechat-debug',
			path: 'wechatDebug',
			fullPath: '/school-information/wechatDebug',
			meta: {
				// title: '微信模拟登录',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/wechatDebug')
		},
		{
			name: 'alipay-debug',
			path: 'alipayDebug',
			fullPath: '/school-information/alipayDebug',
			meta: {
				// title: '支付宝模拟登陆',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/alipayDebug')
		},
		{
			name: 'swipeCard-debug',
			path: 'swipeCardDebug',
			fullPath: '/school-information/swipeCardDebug',
			meta: {
				// title: '模拟刷卡',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/swipeCardDebug')
		},
		{
			name: 'info-student-manage',
			path: 'student-manage',
			fullPath: '/school-information/student-manage',
			// redirect: '/school-information/student-manage/info',
			meta: {
				// title: '学生管理',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/student-manage/student')
		},
		{
			name: 'student-import-export',
			path: 'import-export',
			fullPath: '/school-information/student-manage/import-export',
			meta: {
				title: '导入/导出/修改学生'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/student-manage/import-export')
		},
		{
			name: 'data-export',
			path: 'data-export',
			fullPath: '/school-information/data-export',
			meta: {
				title: '数据导出'
			},
			component: () =>
				import(/* webpackChunkName: "school-information" */ '@/views/school-information/data-export')
		}
	]
};
